import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=03da63ee&"
import script from "./CreateUser.js?vue&type=script&lang=js&"
export * from "./CreateUser.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports